<template>
  <div>
    <!--begin::Advance Table Widget 10-->
    <div class="card card-custom gutter-b">
      <!--begin::Alert-->
      <b-alert :show="true" variant="secondary" class="font-size-lg">
        <p>提示：</p>
        <p>
          1.累计消费满700元可申请开票，发票会在每周三开始处理，预计一周内发送到你的邮箱
        </p>
        <p>2.对公转账的金额才能用于开专用发票，如需开专票请备注说明</p>
        <p>3.请认真核对发票抬头信息，信息有误的申请将拒绝处理</p>
      </b-alert>

      <!--end::Alert-->

      <!--begin::Header-->
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label text-dark">
            <span>可开票金额</span>
            <span class="font-size-h2">{{ waitOpenVoicePrices }}</span>
            <span>元</span>
          </span>
        </h3>
        <div class="card-toolbar">
          <v-btn
            v-if="waitOpenVoicePrices >= 700"
            color="primary font-weight-bolder font-size-sm"
            dark
            @click="openInvoice"
            >申请开票</v-btn
          >
          <v-btn v-else disabled>申请开票</v-btn>
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body py-0">
        <!--begin::Table-->
        <div class="table-responsive">
          <table
            class="table table-head-custom table-vertical-center"
            id="kt_advance_table_widget_4"
          >
            <thead>
              <tr class="text-left">
                <th class="pl-0" style="width: 30px">
                  <label class="checkbox checkbox-lg checkbox-single mr-2">
                    <input
                      type="checkbox"
                      @input="setCheck($event.target.checked)"
                    />
                    <span></span>
                  </label>
                </th>
                <th class="pl-0" style="min-width: 120px">申请时间</th>
                <th style="min-width: 110px">企业名称</th>
                <th style="min-width: 110px">发票金额（元）</th>
                <th style="min-width: 110px">发票电子邮箱</th>
                <th style="min-width: 110px">状态</th>
                <th style="min-width: 120px">备注</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, i) in invoiceList">
                <tr v-bind:key="i">
                  <td class="pl-0 py-6">
                    <label class="checkbox checkbox-lg checkbox-single">
                      <input type="checkbox" :value="i" :checked="checked" />
                      <span></span>
                    </label>
                  </td>
                  <td class="pl-0">
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.ctime | parseTime("{m}/{d}/{y}") }}</span
                    >
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.inv_title.business_name }}</span
                    >
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.inv_prices / 100 }}</span
                    >
                  </td>

                  <td>
                    <span
                      class="text-primary font-weight-bolder d-block font-size-lg"
                      >{{ item.inv_title.email }}</span
                    >
                  </td>
                  <td>
                    <span
                      v-if="item.status"
                      class="label label-lg label-inline label-light-primary"
                      >已发</span
                    >
                    <span
                      v-else
                      class="label label-lg label-inline label-light-warning"
                    >
                      待发
                    </span>
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.memo }}</span
                    >
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Body-->
    </div>
    <!--end::Advance Table Widget 10-->
    <b-pagination
      v-model="currentPage"
      :total-rows="pagination.total"
      :per-page="limit"
      aria-controls="my-table"
      class="mt-3 text-right float-right"
    ></b-pagination>
  </div>
</template>

<script>
import { getInstance } from "@/api/instance";

export default {
  name: "Invoice",
  data() {
    return {
      checked: false,
      invoiceList: [],
      pagination: {
        total: "",
      },
      currentPage: 1,
      limit: 10,
      list: [],
      waitOpenVoicePrices: 0,
    };
  },
  components: {},
  watch: {
    currentPage: {
      handler: function () {
        this.fetchInvoice({
          status: false,
          $limit: this.limit,
          $start: this.currentPage * this.limit - this.limit,
        });
      },
      deep: true,
    },
  },
  created() {
    this.fetchExpend();
    this.fetchInvoice({ status: false, $limit: this.limit });
  },
  methods: {
    setCheck(check) {
      if (check) {
        this.checked = check;
      } else {
        this.checked = false;
      }
    },
    fetchExpend() {
      getInstance("EXPEND", { open_invoice_status: 0 }).then((res) => {
        res.result.forEach((item) => {
          this.waitOpenVoicePrices += item.expend / 100;
        });
      });
    },
    fetchInvoice(params) {
      getInstance("INVOICE", params).then((res) => {
        this.pagination.total = res.total;
        this.invoiceList = res.result;
      });
    },
    openInvoice() {
      this.$router.push({ name: "open-invoice" });
    },
  },
};
</script>
